module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/zoom-in-simple-f5e3752e714f0ceab87553a0b74c06f5.svg";